import React from "react";
import LogoCarousel from "./LogoCarasol";

const Testimonial = () => {
  return (
    <div id="testi" className="container my-4">
      <div className="row align-items-center">
        <div className="col-lg-0">
          <h1 className="about-heading fw-bold mb-4">Our Customers</h1>
          <p>
            We deeply appreciate our valued customers for their trust and
            support. Your loyalty inspires us to deliver excellence every day.
            Thank you for being a part of our journey!
          </p>
        </div>
      </div>

      {/* Bootstrap Multi-Item Image Carousel */}
      <LogoCarousel />
    </div>
  );
};

export default Testimonial;
